import { render, staticRenderFns } from "./NewsViewModal.vue?vue&type=template&id=84a5f8b8&scoped=true"
import script from "./NewsViewModal.vue?vue&type=script&lang=js"
export * from "./NewsViewModal.vue?vue&type=script&lang=js"
import style0 from "./NewsViewModal.vue?vue&type=style&index=0&id=84a5f8b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a5f8b8",
  null
  
)

export default component.exports